import { AppBar, Toolbar, Box } from '@mui/material';

import ImageWrapper from '@/components/ImageWrapper';
import TAGLink from '@/components/TAGLink';

import NavigationBar from '../NavigationBar';
import { IHeaderWithLocationNav } from '../HeaderWithLocationNav';
import LocationNavBar from '../LocationNavBar';

import {
	logoStyles,
	headerStyles,
	navigationStyles,
	navigationLinkStyles,
	toolbarStyles,
	toolbarWrapStyles,
} from './HeaderDesktop.styles';

export default function HeaderDesktop({ logoUrl, logoHref = '/', headerData }: Readonly<IHeaderWithLocationNav>) {
	return (
		<AppBar data-test-id="header_desktop_with_location_nav" sx={headerStyles}>
			<Toolbar disableGutters sx={toolbarStyles}>
				<Box sx={toolbarWrapStyles}>
					<TAGLink href={logoHref}>
						<ImageWrapper
							src={logoUrl}
							width="unset"
							height="unset"
							sx={logoStyles}
							data-test-id="img_logo_desktop_with_location_nav"
							alt="brand logo"
						/>
					</TAGLink>
					<NavigationBar
						navigationItems={headerData?.navigationLinksCollection}
						navigationSx={navigationStyles}
						navigationLinkSx={navigationLinkStyles}
					/>
					<NavigationBar
						navigationItems={headerData?.secondaryNavigationLinksCollection}
						navigationSx={navigationStyles}
						navigationLinkSx={navigationLinkStyles}
						linkColor="text.interactive"
						fontWeight={700}
						showIconText={true}
					/>
				</Box>
			</Toolbar>
			<LocationNavBar
				schedulingButtonText={headerData?.schedulingButtonText}
				locationBarFindOfficeUrl={headerData?.locationBarFindOfficeUrl}
				searchFieldTitle={headerData?.searchFieldTitle}
			/>
		</AppBar>
	);
}
